import { Box, Button, CircularProgress, Container } from "@mui/material";
import { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import useSnackbar from "../components/snackbar/useSnackBar";
import { useApi } from "../hooks/useApi";

/**
 * Implements the Admin-Overview.
 * @returns 
 */
export default function Admin() {

  const [isLoading, setIsLoading] = useState(false);

  const { openSnackBar } = useSnackbar();

  const intl = useIntl();

  const api = useApi();

  const triggerImport = () => {
    setIsLoading(true);
    api
      .post('/export/import')
      .then(() => {
        openSnackBar(intl.formatMessage({ id: 'Admin.importSuccessful' }));
      })
      .catch(error => {
        console.log(error);
        openSnackBar(intl.formatMessage({ id: 'Admin.importFailed' }));
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <Container>
      {isLoading && <Box
        sx={{
          marginTop: 3,
          marginBottom: 3,
          position: "fixed",
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: "center",
          alignItems: "center",
          zIndex: 10
        }}
      >
        <CircularProgress color="primary" />
      </Box>}
      <h3><FormattedMessage id="Admin.heading" /></h3>

      <Box sx={{ mt: 1 }}>
        <Button
          fullWidth
          variant="contained"
          onClick={triggerImport}
          sx={{ mt: 3, mb: 2 }}
        >
          <FormattedMessage id="Admin.importButton" />
        </Button>
      </Box>
    </Container>
  )
};